import { Component, Input } from '@angular/core';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { ContractDetails } from '../../../../core/store/contract-details/contract-details.interface';
import { fadeInAnimation } from '../../../../animations';
import { goAction } from '../../../../core/store/router/router.actions';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-service-boxes',
  templateUrl: './service-boxes.container.html',
  styleUrls: ['./service-boxes.container.scss'],
  animations: [fadeInAnimation], // TODO FIRST check if possible in baseContainer
})
export class ServiceBoxesContainer extends BaseContainer {
  phoneNumber: string;
  emailAddress: string;

  @Input() hideFAQ: boolean = false;

  constructor() {
    super();

    this.store
      .select('contractDetails')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((contractDetails: ContractDetails) => {
        this.phoneNumber = contractDetails.customerSummary.salesOrganisation.phoneNumber;
        this.emailAddress = contractDetails.customerSummary.salesOrganisation.emailAddress;
      });
  }

  openModule(path: string) {
    this.store.dispatch(goAction({ path }));
  }
}
